import React, {useEffect, useRef} from "react";
import * as echarts from "echarts/core";
import {BarChart, LineChart, PieChart, SankeyChart, ScatterChart} from "echarts/charts";
import {GridComponent, LegendComponent, MarkLineComponent, TooltipComponent} from "echarts/components";
import {CanvasRenderer} from "echarts/renderers";

echarts.use([
    BarChart,
    LineChart,
    PieChart,
    SankeyChart,
    ScatterChart,
    GridComponent,
    LegendComponent,
    MarkLineComponent,
    TooltipComponent,
    CanvasRenderer,
]);

export default function EChart({option, className = "h-72", height, loading = false}) {
    const chartElement = useRef(null);
    const chartInstance = useRef(null);

    useEffect(() => {
        if (chartElement.current === null) {
            return;
        }

        const element = chartElement.current;
        chartInstance.current = echarts.init(element, null, {
            renderer: "canvas",
        });

        let resizeFrame = null;
        const resizeChart = () => {
            if (resizeFrame !== null) {
                window.cancelAnimationFrame(resizeFrame);
            }

            resizeFrame = window.requestAnimationFrame(() => {
                resizeFrame = null;
                chartInstance.current?.resize();
            });
        };
        const resizeObserver = typeof ResizeObserver === "undefined" ? null : new ResizeObserver(resizeChart);
        resizeObserver?.observe(element);
        window.addEventListener("resize", resizeChart);

        return () => {
            if (resizeFrame !== null) {
                window.cancelAnimationFrame(resizeFrame);
            }
            resizeObserver?.disconnect();
            window.removeEventListener("resize", resizeChart);
            chartInstance.current?.dispose();
            chartInstance.current = null;
        };
    }, []);

    useEffect(() => {
        if (chartInstance.current === null) {
            return;
        }

        if (loading) {
            chartInstance.current.showLoading("default", {
                color: "#7c3aed",
                textColor: "#64748b",
                maskColor: "rgba(255, 255, 255, 0.65)",
            });
            return;
        }

        chartInstance.current.hideLoading();
        chartInstance.current.setOption(option ?? {}, true);
    }, [option, loading]);

    return <div ref={chartElement} className={`min-w-0 w-full ${className}`} style={height ? {height} : undefined}/>;
}
